import { createPreference, fetchPreferenceByKey } from '@creditsights/api-ui-web';
import { useQuery, UseQueryResult } from 'react-query';
import { ArticleTableRow } from '../../models/ArticleTableRow';
import { ArticleListItemDto } from '../../services/dtos/article/articleListItem.dto';
import { PreferencesKey } from '../../services/services.constants';
import { mapArticleListItemDtoToArticleTableRow } from '../articles/utils/article.mappers';
import { queryKeys } from '../queryKeyFactory';

export const MAX_RECENTLY_VIEWED_SAVED = 10;

export default (enabled = true): UseQueryResult<ArticleTableRow[], Error> => {
  return useQuery<ArticleTableRow[], Error>(
    [queryKeys.fetchRecentlyViewed.all],
    async () => {
      try {
        const recentlyViewed = await fetchPreferenceByKey<ArticleListItemDto[]>(PreferencesKey.recentlyViewed);

        return mapArticleListItemDtoToArticleTableRow(recentlyViewed.value).slice(0, MAX_RECENTLY_VIEWED_SAVED);
      } catch (error: any) {
        if (error.request?.status === 404) {
          await createPreference({ key: PreferencesKey.recentlyViewed, value: [] });

          return [];
        }

        throw error;
      }
    },
    {
      staleTime: 0,
      enabled,
    }
  );
};
